// src/pages/Workflows/Editor/utils/typeCompatibility.js
// Matriz de compatibilidade de tipos entre nós
// Determina se uma ligação entre dois nós é válida

/**
 * Mapa: outputType → array de inputTypes aceites
 */
const COMPATIBILIDADE = {
  file_ref_list: ['file_ref_list'],
  text: ['text'],
  transcricao_list: ['text', 'transcricao_list'],
  json_object: ['text', 'json_object'],
  json_list: ['text', 'json_list'],
};

/**
 * Verifica se um tipo de output é compatível com um tipo de input aceite.
 * @param {string} outputType - tipo produzido pelo nó fonte
 * @param {string[]} tiposAceites - tipos aceites pelo campo de destino
 * @returns {boolean}
 */
export function isCompativel(outputType, tiposAceites) {
  if (!outputType || !tiposAceites || tiposAceites.length === 0) return false;
  const compatíveis = COMPATIBILIDADE[outputType] || [];
  return tiposAceites.some(t => compatíveis.includes(t));
}

/**
 * Dado um outputType de source, retorna quais inputTypes são compatíveis.
 * Útil para highlight de portas válidas ao arrastar.
 */
export function tiposCompativeisComOutput(outputType) {
  return COMPATIBILIDADE[outputType] || [];
}

export default COMPATIBILIDADE;
